/* eslint-disable react/jsx-props-no-spreading */
// DESIGN_SYSTEM_GENERATED_ICONS
import React from 'react';
import Icon from './icons';
function Minus(props) {
    return (React.createElement(Icon, Object.assign({ viewBox: "0 0 18 2" }, props),
        React.createElement("path", { d: "M0 1C0 0.447715 0.447715 0 1 0H17C17.5523 0 18 0.447715 18 1C18 1.55228 17.5523 2 17 2H1C0.447716 2 0 1.55228 0 1Z", fill: "#001325", fillOpacity: "0.92" })));
}
export default Minus;
